import React from 'react';

//style
import styles from './Index.module.css'

//Components
import PageHeader from '../../../PageHeader/PageHeader';
import Profil from '../../components/Profil.js'
import PageInfo from '../../components/PageInfo.js';
import PageState from '../../components/PageState.js';
import RenderItems from '../../components/RenderItems.js';

//Utils
import renderItem from '../../components/RenderItems.js';

export default function LedelseAnsatte() {
    return(
        <PageState
            pageName="LedelseAnsatte"
            render={({ data, sections, sectionNames }) => {

                const { Sec1, Sec2, Sec3, Sec4} = data

                    console.log("sections:", sections);
                    console.log("sectionNames:", sectionNames);

                return (
                    <div>
                        <PageHeader title={data.PageHeader.title} image={data.PageHeader.imageUrl} description={data.PageHeader.text} sections={sections} sectionNames={sectionNames}></PageHeader>
                        {/* Præster */}
                        <section id = {Sec1.secId} className={styles.employeesWrapper1}>
                            <PageInfo
                                title={Sec1.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>}/>
                            <div className={styles.employees}>
                                {(Sec1.items || []).map((item) => renderItem(item, Sec1[item.sectionKey]))}
                            </div>
                        </section>
                        {/* Menighedstjenere */}
                        <section id = {Sec2.secId} className={styles.employeesWrapper2}>
                            <PageInfo
                                title={Sec2.header}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }}/>}/>
                            <div className={styles.employees}>
                                {(Sec2.items || []).map((item) => renderItem(item, Sec2[item.sectionKey]))}
                            </div>
                            {/* <Textbox description={<div dangerouslySetInnerHTML={{ __html: Sec2.text2 }}/>}/> */}
                        </section>
                        {/* LM nordsjælland */}
                        <section id ={Sec3.secId} className={styles.sec3}>
                            <div className={styles.header}>
                                <div className={styles.headerImg} style={{ backgroundImage: `url(${Sec3.imageUrl})` }}/>
                                <div className={styles.headerText}>
                                    <h1>{Sec3.header}</h1>
                                    <div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>
                                </div>
                            </div>
                            <PageInfo
                                title={""}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec3.item1.text }}/>}
                                image={Sec3.item1.imageUrl}
                                version={"v3"}/>
                        </section>
                        {/* udsendte missionærer */}
                        <section id = {Sec4.secId} className={styles.sec4}>
                            <div className={styles.header}>
                                <div className={styles.headerImg} style={{ backgroundImage: `url(${Sec4.imageUrl})` }}/>
                                <div className={styles.headerText}>
                                    <h1>{Sec4.header}</h1>
                                    <div dangerouslySetInnerHTML={{ __html: Sec4.text }}/>
                                </div>
                            </div>
                            {/* Maiken i Mongoliet */}
                            <div className={styles.profilSec} >
                                <PageInfo 
                                    title={Sec4.item1.title}
                                    image={Sec4.item1.imageUrl}
                                    description={<div dangerouslySetInnerHTML={{ __html: Sec4.item1.text }}/>}
                                    version={"v5"}/>
                            </div>
                            <div className={styles.profilSec2}>
                            <PageInfo
                                title={Sec4.item2.title}
                                image={Sec4.item2.imageUrl}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec4.item2.text }}/>}
                                version={"v4"}/>
                            </div>
                            <div className={styles.profilSec}>
                            <PageInfo
                                title={Sec4.item3.title}
                                image={Sec4.item3.imageUrl}
                                description={<div dangerouslySetInnerHTML={{ __html: Sec4.item3.text }}/>}
                                version={"v5"}/>
                            </div>
                        </section>
                    </div>
                );
            }
        }/>
    );
}